// extracted by mini-css-extract-plugin
export default {"deleteDatasetForm":"styles_deleteDatasetForm__EKjaT","text":"styles_text__LBMdJ","checkbox":"styles_checkbox__dz9QN"};